import { useEffect, useState } from 'react';

const trustItems = [
  'Care Inspectorate registered',
  'PVG checked carers',
  'Same carer, every visit',
  'Same-day response',
];

export default function Hero() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(t);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex flex-col lg:flex-row overflow-hidden bg-[#1C2B3A]">

      {/* Left — text content */}
      <div className="relative z-10 flex flex-col justify-between w-full lg:w-1/2 px-6 md:px-12 lg:px-16 pt-32 pb-12 lg:py-0 lg:justify-center min-h-[60vh] lg:min-h-screen">

        <div>
          <p
            className="text-[#D4A574] text-[10px] tracking-[0.32em] uppercase font-semibold mb-8 transition-all duration-700 ease-out"
            style={{ opacity: mounted ? 1 : 0, transform: mounted ? 'none' : 'translateY(8px)', transitionDelay: '80ms' }}
          >
            Edinburgh &amp; across Scotland
          </p>

          <h1
            className="text-white font-bold leading-[1.06] mb-8 transition-all duration-700 ease-out"
            style={{
              fontSize: 'clamp(2.8rem, 6vw, 4.8rem)',
              opacity: mounted ? 1 : 0,
              transform: mounted ? 'none' : 'translateY(20px)',
              transitionDelay: '160ms',
            }}
          >
            Care that lets<br />
            you stay{' '}
            <span className="relative inline-block">
              <span style={{ color: '#D4A574', fontStyle: 'italic' }}>home.</span>
            </span>
          </h1>

          <p
            className="text-white/55 text-[15px] leading-relaxed mb-10 max-w-sm transition-all duration-700 ease-out"
            style={{
              opacity: mounted ? 1 : 0,
              transform: mounted ? 'none' : 'translateY(12px)',
              transitionDelay: '260ms',
            }}
          >
            Professional, compassionate home care across Scotland. Built around the person, not a schedule.
          </p>

          <div
            className="flex flex-col sm:flex-row items-start gap-3 mb-14 transition-all duration-700 ease-out"
            style={{ opacity: mounted ? 1 : 0, transform: mounted ? 'none' : 'translateY(10px)', transitionDelay: '360ms' }}
          >
            <button
              onClick={() => scrollTo('contact')}
              className="bg-[#C0706A] hover:bg-[#a85f59] text-white font-bold px-7 py-3 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap rounded-lg"
            >
              Get in touch
            </button>
            <button
              onClick={() => scrollTo('how-it-works')}
              className="text-white/50 hover:text-white text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2 group px-1 py-3"
            >
              How it works
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
            </button>
          </div>
        </div>

        {/* Trust signals — inline, no icons */}
        <div
          className="transition-all duration-700 ease-out"
          style={{ opacity: mounted ? 1 : 0, transitionDelay: '500ms' }}
        >
          <div className="border-t border-white/10 pt-6 flex flex-wrap gap-x-6 gap-y-2">
            {trustItems.map((item) => (
              <span key={item} className="text-white/40 text-xs font-medium flex items-center gap-1.5">
                <span className="w-1 h-1 rounded-full bg-[#C0706A] inline-block shrink-0"></span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Right — image panel */}
      <div
        className="relative w-full lg:w-1/2 h-[45vw] lg:h-auto lg:min-h-screen overflow-hidden transition-all duration-1000 ease-out"
        style={{ opacity: mounted ? 1 : 0, transitionDelay: '200ms' }}
      >
        <img
          src="https://images.pexels.com/photos/7551652/pexels-photo-7551652.jpeg?auto=compress&cs=tinysrgb&w=1200"
          alt="Carer attending to elderly client at home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1C2B3A]/60 via-transparent to-transparent lg:from-[#1C2B3A]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C2B3A]/50 via-transparent to-transparent" />

        {/* Floating stat card */}
        <div
          className="absolute bottom-8 right-8 bg-white/95 rounded-xl px-5 py-4 max-w-[180px] transition-all duration-700 ease-out"
          style={{ opacity: mounted ? 1 : 0, transform: mounted ? 'none' : 'translateY(12px)', transitionDelay: '700ms' }}
        >
          <p className="text-[#C0706A] font-bold text-2xl leading-none mb-1">1:1</p>
          <p className="text-[#2C3E50]/70 text-xs leading-snug">Dedicated carer per client, every time</p>
        </div>
      </div>

    </section>
  );
}
